import { getOrgMemberCountsDef } from '../../../../../backend/features/organizations/shared';
import { useContactManagementTranslation } from '../../../../../ui/hooks/useContactManagementTranslation';
import { useTypedPlatformFunctionResponse } from '@juvare/platform-sdk-react/ui/features/typed-platform-functions';
import { Alert, Card, CardContent, CardHeader, LinearProgress, Link, Typography } from '@mui/material';
import React from 'react';
export const PendingMemberships = (props) => {
    const { t } = useContactManagementTranslation();
    const { data, isLoading, error } = useTypedPlatformFunctionResponse(getOrgMemberCountsDef, {});
    const PendingMembershipsCardContent = () => {
        if (error) {
            return React.createElement(Alert, { severity: 'error' }, t('common.errorMessage'));
        }
        if (isLoading) {
            return React.createElement(LinearProgress, null);
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Typography, { sx: { pb: 2 }, "data-test": 'pending-memberships-count', variant: 'body1' }, t('panels.organizations.pendingMember', { count: data === null || data === void 0 ? void 0 : data.totalMemberCount })),
            props.onNavigateToOrganizations && (React.createElement(Link, { sx: { mt: 2, cursor: 'pointer' }, onClick: () => props.onNavigateToOrganizations && props.onNavigateToOrganizations(), variant: 'body1', "data-test": 'pending-members-count-link', tabIndex: 0 }, t('panels.organizations.goToManagedOrganizations')))));
    };
    return (React.createElement(Card, { "data-test": 'pending-memberships-card', sx: { width: '100%', height: '100%' } },
        React.createElement(CardHeader, { title: t('panels.organizations.pendingMemberships'), "data-test": 'pending-memberships-card-title' }),
        React.createElement(CardContent, { "data-test": 'pending-memberships-card-content' },
            React.createElement(PendingMembershipsCardContent, null))));
};
